import { useNavigationContext } from '../../../contexts/NavigationContext';
import ProspectPage from './Prospect/ProspectPage';
import MainLayout from '../../../components/Display/MainLayout';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout scope={'gensdemer'} websiteLabel={"lesgensdemer.cc"}>
      <ProspectPage isActive={navigationContext.activeAppKey === 'gdmprospect'} />
    </MainLayout>
  );
}

export default Home;
